import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrIcons from '@components/BrIcons';
import './brNotification.scss';

export const types = {
  info: 'info',
  warn: 'warn',
  error: 'error',
  success: 'success',
  successCheckV2: 'successCheckV2',
};

const typeToIcon = {
  info: <BrIcons.Info isSubComp />,
  warn: <BrIcons.Warning isSubComp />,
  error: <BrIcons.Stop isSubComp />,
  success: <BrIcons.Check isSubComp />,
  successCheckV2: <BrIcons.SuccessCheckV2 isSubComp />,
};

export default class BrNotification extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
    messageId: PropTypes.string,
    children: PropTypes.any,
    type: PropTypes.oneOf(Object.keys(types)),
    // isFloat: PropTypes.bool,  // NOT IMPLMENTED
    isTimed: PropTypes.bool,
    timespan: PropTypes.number,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    type: types.info,
    isFloat: false,
    isTimed: false,
    timespan: 10,
    useV2Icons: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isHidden: false,
    }; // may use initial props
    this.timer = null;
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    // setState -> no rerender
    // this step is will not be invoked by this.setState
    if (this.props.message !== nextProps.message || this.props.messageId !== nextProps.messageId) {
      this.setState({ isHidden: false });
    }
  }

  componentDidMount() {
    if (this.props.isTimed && !this.timer) {
      const timespan = this.props.timespan || 3000;
      this.timer = setTimeout(() => this.hideNotification(), timespan);
    }
  }

  componentDidUpdate() {
    // network request
    // dom handling
    if (this.props.isTimed && !this.timer) {
      const timespan = this.props.timespan || 3000;
      this.timer = setTimeout(() => this.hideNotification(), timespan);
    }
  }

  hideNotification = () => {
    this.setState({ isHidden: true });
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { className, message, children, type, onClose, useV2Icons } = this.props;
    const { isHidden } = this.state;
    const classname = cn('br-notification', type, className, { hidden: isHidden });
    return (
      <div className={classname} data-id="br-notification">
        <div className="br-notification-icon">{typeToIcon[type]}</div>
        <div className="br-notification-message">{message || children}</div>
        {onClose && (
          <div className="br-notification-close" onClick={this.hideNotification}>
            {useV2Icons ? <BrIcons.CrossCheckV2 isSubComp /> : <BrIcons.Cross isSubComp />}
          </div>
        )}
      </div>
    );
  }
}
